"use client";

import { useState } from "react";
import Image from "next/image";
import { cn } from "@/lib/utils";

// Foto van de trekker, vóór de naam. Niet elke machine heeft er een - de
// koppeling loopt op naam tussen de live-pagina en onze eigen kopie - dus
// zonder foto vallen we terug op de initialen.
export function MachineFoto({
  src,
  naam,
  groot,
}: {
  src: string | null;
  naam: string;
  groot?: boolean;
}) {
  const [fout, setFout] = useState(false);

  const initialen = naam
    .split(/\s+/)
    .slice(0, 2)
    .map((w) => w[0] ?? "")
    .join("")
    .toUpperCase();

  const maat = groot ? "size-14" : "size-10";

  if (!src || fout) {
    return (
      <div
        className={cn(
          maat,
          "flex shrink-0 items-center justify-center rounded-lg border border-primary/40 bg-muted font-display font-black text-primary",
          groot ? "text-base" : "text-xs",
        )}
        aria-hidden
      >
        {initialen || "?"}
      </div>
    );
  }

  return (
    <div className={cn(maat, "relative shrink-0 overflow-hidden rounded-lg bg-muted")}>
      <Image
        src={src}
        alt=""
        fill
        sizes={groot ? "56px" : "40px"}
        onError={() => setFout(true)}
        className="object-cover"
      />
    </div>
  );
}
